// formStore.js
import create from 'zustand';

const getColorHex = (colorName) => {
    switch (colorName) {
        case 'Antraciet':
            return ['#353C40', 1]; // Antraciet color in hexadecimal
        case 'Creme':
            return ['#E9E0D2', 1]; // Antraciet color in hexadecimal
        case 'Zwart':
            return ['#0A0C10', 1]; // Antraciet color in hexadecimal
        case 'Helder - Polycarbonnat':
            return ['#FFFFFF', 0.7];
        case 'Opaal - Polycarbonnat':
            return ['#F0F8FF', 1];
        case 'Zonwerend - Polycarbonnat':
            return ['#FFD700', 0.8];
        case 'Glas':
            return ['#ccc', 0.25];
        case 'Getint Glas':
            return ['#023020', 0.96];
        case 'Melk Glas':
            return ['#FFFFFF', 0.8];
        default:
            return ['#00', 1]; // Return empty string for unknown colors
    }
};

const profileKeys = [
    "TK8148", "TKGLS003", "TK8150", "TK8149", "TK8114",
    "TK8117", "TK8121", "TK8113", "TK8118", "TK8124",
    "TK8123", "TKCOV001", , "TKCOV003", "TK95701", "TKSCR012", "TKSCR001", "TKSCR002", "TKSCR041", "TKSCR043", "TKCON001", "TKCON002", "TKGAS003", "TKGAS001", "TKLAM001", "TKLAM003", "TKLAM004", "TKCON006", "TKCON003", "TKCON004", "TKCON005",

];

// Memoization of generateProfiles
const generateProfiles = (() => {
    const profiles = {};
    profileKeys.forEach(key => {
        profiles[key] = {
            price: 0,
            extra_fields: {
                weight: 0
            }
        };
    });
    return profiles;
})();


export const useFormStore = create((set) => ({

    activeTab: 'purchase_mode', // Default active tab
    setActive: tab => set({ activeTab: tab }), // Function to set active tab
    formData: {
        // Initial form data
        purchase_mode: {
            mode_option: "Complete Veranda"
        },
        maat: {
            breedte: "600",
            uitval: "300",
            doorloop_hoogte: "220",
            uitval_type: ""
        },
        uitval_type: {
            uitval_type_option: "Buiten staander"
        },
        kleur: {
            kleur_option: "Antraciet"
        },
        dak: {
            dak_option: "Helder - Polycarbonnat"
        },
        zonwering: {
            zonwering_option: "Nee"
        },
        verlichting: {
            led_option: "Nee",
            led_patroon_option: "Geen"
        },
        linker: {
            linker_wand_option: "Geen",
            linker_spie_option: "Geen"

        },
        rechter: {
            rechter_wand_option: "Geen",
            rechter_spie_option: "Geen"

        },

        gutter: {
            goot_option: 'Rond'
        },
        voorkant: {
            schuifdeur: "Geen"
        },
        voorkant_glazen_schuifdeur_options: {
            glazen_schuifdeur_type: "Helder Glas"
        },
        voorkant_alum_schuifdeur_options: {
            voorkant_schuifdeur_handle: 'Rechts'
        },
        total: {
            price: 0,
        }
    },
    profiles: generateProfiles,
    setProfiles: (newProfiles) => set({ profiles: newProfiles }),
    setFormData: (data) => set({ formData: data }),

    getVerandaColor: () => {
        const state = useFormStore.getState();
        const { kleur_option } = state.formData.kleur;
        return getColorHex(kleur_option);
    },
    getDakColor: () => {
        const state = useFormStore.getState();
        const { dak_option } = state.formData.dak;
        return getColorHex(dak_option);
    },
    getLeftSpieColor: () => {
        const state = useFormStore.getState();
        const { linker_spie_option } = state.formData.linker;
        return getColorHex(linker_spie_option);
    },
    getRightSpieColor: () => {
        const state = useFormStore.getState();
        const { rechter_spie_option } = state.formData.rechter;
        return getColorHex(rechter_spie_option);
    },
    getRightFixedPanelColor: () => {
        const state = useFormStore.getState();
        const { rechter_wand_option } = state.formData.rechter
        return getColorHex(rechter_wand_option);
    },
    getLeftFixedPanelColor: () => {
        const state = useFormStore.getState();
        const { linker_wand_option } = state.formData.linker
        return getColorHex(linker_wand_option);
    },
    getNumberOfBeams: () => {
        const state = useFormStore.getState();
        const GlassWidth = 80;
        const { breedte } = state.formData.maat;

        return Math.ceil(breedte / GlassWidth);
    },
    getNumberOfGlassDoors: () => {
        const state = useFormStore.getState();
        const { breedte } = state.formData.maat;
        return Math.ceil(breedte / 100);
    },
    calculateSizes: () => {
        // Calculate sizes based on formValues
        const state = useFormStore.getState();

        const { breedte, uitval, doorloop_hoogte } = state.formData.maat;

        // Perform calculations
        const skeletonBreedte = parseInt(breedte) / 600;
        const skeletonUitval = parseInt(uitval) / 300;
        const skeletonDoorloopHoogte = 1; //parseInt(doorloop_hoogte) / 220;

        // Update sizes in the store
        return [skeletonBreedte, skeletonDoorloopHoogte, skeletonUitval];
        /*     return {
                sizes: {
                    skeletonBreedte,
                    skeletonUitval,
                    skeletonDoorloopHoogte
                }
            }; */
    }
}));
